import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import { REASON } from "MODULES/SalesOrders/constants";
import { RETURN_TO_TYPE } from "APP_ROOT/constants";
import { WARRANTY_CONSIDERATION } from "MODULES/RepairOrders/constants";
import {
  CREDIT_REQUESTED,
  PARTIAL_CREDIT_AMT,
  PARTIAL_CREDIT_REQUESTED
} from "MODULES/RMAsAndWarranties/constants";
import { OTHER } from "MODULES/shared/constants";

export function validate(values) {
  return validator(values, f => {
    f.validate(REASON).satisfies(rules.required);
    f.validate(RETURN_TO_TYPE).satisfies(rules.required);
    if (values.reason === OTHER) {
      f.validate("other_reason").satisfies(rules.required);
    }

    f
      .validate(WARRANTY_CONSIDERATION)
      .satisfies(
        rules.customerRmaRequest(
          1,
          WARRANTY_CONSIDERATION,
          CREDIT_REQUESTED,
          PARTIAL_CREDIT_REQUESTED
        )
      );

    if (values.partial_credit_requested) {
      rules.required(PARTIAL_CREDIT_AMT);
    }
  });
}



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/RmaRequest/validate.js